import { jsx as _jsx } from "react/jsx-runtime";
/**
 * RegisterPage — embeds Clerk's <SignUp> component within the app's own layout.
 *
 * What Clerk handles here:
 *   • Email address entry and verification (sends a one-time code)
 *   • Password creation (enforced by Clerk's password policy in the dashboard)
 *   • Optional: first name / last name (if enabled in Clerk dashboard settings)
 *
 * What happens after signup:
 *   afterSignUpUrl="/onboarding" — Clerk redirects here once the email is
 *   verified and the Clerk account is fully created. The onboarding page then
 *   collects the app-specific fields (username, DOB, country, terms) and POSTs
 *   to /auth/complete-profile to finalise the local user record.
 *
 * App.tsx registers `/register/*` so that Clerk's multi-step sub-paths
 * (e.g. /register/verify-email-address) are handled by React Router.
 */
import { SignUp } from '@clerk/clerk-react';
export function RegisterPage() {
    return (_jsx(SignUp, { routing: "path", path: "/register", signInUrl: "/login", afterSignUpUrl: "/onboarding", appearance: {
            variables: {
                colorPrimary: '#7c2d12', // wine-800
                colorBackground: '#ffffff',
                borderRadius: '0.5rem',
                fontFamily: 'inherit',
            },
            elements: {
                card: 'shadow-none border-0',
                headerTitle: 'text-xl font-semibold text-gray-900',
                headerSubtitle: 'text-sm text-gray-500',
                formButtonPrimary: 'bg-wine-700 hover:bg-wine-800 text-white font-medium py-2.5 rounded-lg transition-colors',
                formFieldInput: 'border-gray-300 rounded-lg focus:ring-wine-600 focus:border-wine-600',
                footerActionLink: 'text-wine-700 hover:text-wine-800 font-medium',
            },
        } }));
}
